import { LcgProductScopeSchema } from "@redotech/redo-conversion-settings-common/landed-cost-settings";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getLcgClassifyProductCounts = {
  name: "getLcgClassifyProductCounts" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.record(LcgProductScopeSchema, z.number()),
};
